function applyMask(ctx, mask) {
  ctx.globalCompositeOperation = 'destination-out';
  ctx.drawImage(mask, 0, 0, ctx.canvas.width, ctx.canvas.height);
  ctx.globalCompositeOperation = 'source-over';
  return ctx.canvas;
}

export { applyMask as default };
